module.exports = __webpack_public_path__ + "static/media/addRecipientGuide1.32c62e32.png";